document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rd-variant]').forEach(select => {
    const form = select.closest('form');
    const price = form?.querySelector('[data-rd-price]');
    const button = form?.querySelector('[data-rd-add]');
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = option?.dataset.available !== 'true';
        button.textContent = option?.dataset.available === 'true' ? 'ADD TO CART' : 'SOLD OUT';
      }
    });
  });
  document.querySelectorAll('[data-rd-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-rd-gallery]');
      const main = gallery?.querySelector('[data-rd-main-image]');
      if (main) { main.src = button.dataset.rdThumb; main.alt = button.dataset.rdAlt || main.alt; }
      gallery?.querySelectorAll('[data-rd-thumb]').forEach(item => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });
  document.querySelectorAll('[data-rd-sort]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});
